'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = autoPlay;
var autoplayFact = {
    weixin: function weixin(cb) {
        return D.wx(function () {
            window.WeixinJSBridge.invoke('getNetworkType', {}, function () {
                cb();
            }, false);
        });
    },
    alipay: function alipay(cb) {
        return D.alipay(function () {
            window.AlipayJSBridge.invoke('getNetworkType', {}, function () {
                cb();
            }, false);
        });
    },
    passenger: function passenger(cb) {
        return D.bridge.call('getSystemInfo', {}, function () {
            return cb();
        });
    },
    driver: function driver(cb) {
        setTimeout(function () {
            if (D && D.bridge && D.bridge.driver) {
                D.bridge.driver.getSystemInfo(function () {
                    cb();
                });
            } else cb();
        }, 200);
    },
    default: function _default(cb) {
        return cb();
    }
};

function autoPlay(cb) {
    if (D.is('weixin')) {
        autoplayFact.weixin(cb);
    } else if (D.is('alipay')) {
        autoplayFact.alipay(cb);
    } else if (D.is('passenger')) {
        autoplayFact.passenger(cb);
    } else if (D.is('driver')) {
        autoplayFact.driver(cb);
    } else {
        autoplayFact.default(cb);
    }
}